import { ContentObjectTypes } from 'content-management-data-lib';
import { useContentUsageLimits } from 'content-management-restrictions-lib';
import { LimitTypes } from 'content-management-restrictions-lib';
import usePortalScopes from 'page-lib/hooks/usePortalScopes';
import useHasHubSpotBrandingOnContentType from 'page-lib/hooks/useHasHubSpotBrandingOnContentType';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const MIN_THRESHOLD_TO_DISPLAY_FREE_BANNER = 5;
const RemoveBrandingBanner = ({
  contentObjectType
}) => {
  const hasHubSpotBrandingOnContent = useHasHubSpotBrandingOnContentType(contentObjectType);
  const {
    getLimitValue,
    getQuantityUsedValue
  } = useContentUsageLimits();
  const {
    hasFetchCompleted
  } = usePortalScopes();
  const limit = getLimitValue(LimitTypes.CONTENT_OBJECT_LIMIT);
  const quantityUsed = getQuantityUsedValue(LimitTypes.CONTENT_OBJECT_LIMIT);
  const numPagesBelowLimit = limit ? limit - quantityUsed : 0;
  const shouldShowRemoveBrandingBanner = hasFetchCompleted && limit !== null && hasHubSpotBrandingOnContent && numPagesBelowLimit > MIN_THRESHOLD_TO_DISPLAY_FREE_BANNER;
  if (!shouldShowRemoveBrandingBanner) {
    return null;
  }
  const upgradeKey = contentObjectType === ContentObjectTypes.LANDING_PAGE ? 'landing-pages-details-page-remove-branding' : 'site-pages-details-page-remove-branding';
  return /*#__PURE__*/_jsx(UIUpgradeBanner, {
    upgradeKey: upgradeKey,
    marginStyle: {
      marginBlockStart: '500',
      marginInline: '500'
    }
  });
};
export default RemoveBrandingBanner;